import script from "./Filters.vue?vue&type=script&setup=true&lang=js"
export * from "./Filters.vue?vue&type=script&setup=true&lang=js"

import "./Filters.vue?vue&type=style&index=0&id=28641fc4&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28641fc4"]])

export default __exports__